import { useState } from "react";
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { useNotificationDispatch } from "../../../../contexts/notification.context";
import { postUserMessageToSlack } from "../functions/postUserMessageToSlack";
import { useUserState } from "../../../../contexts/user.context";

export function FeedbackModal({ modalState, setModalState }: HelpModalProps) {
  const user = useUserState();
  const notificationDispatch = useNotificationDispatch();
  const [textAreaValue, setTextAreaValue] = useState("");
  return (
    <div className="relative">
      <ComponentLibrary.PCDialogueBox
        open={modalState}
        width={"width-14"}
        height={"height-12"}
        onClose={() => {
          setModalState(!modalState);
          setTextAreaValue("");
        }}>
        <div className="mh3">
          <div className="flex flex-column mv3">
            <ComponentLibrary.PCHeader text="Share Feedback" />
            <div className="mt1 mid-gray f5 platform-font">Have an idea of how we can improve your experience with Picnic Studio?</div>
          </div>
          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
          <ComponentLibrary.PCTextArea rows={9} value={textAreaValue} id={"feedback-text-input"} placeholder={""} spellCheck={false} maxLength={280} changeHandler={(e) => setTextAreaValue((e.target as HTMLTextAreaElement).value)} />
          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
          <ComponentLibrary.PCActionButton
            text="Send Feedback"
            textColor={"white"}
            color={"background-color-primary-3"}
            width={"100%"}
            height={"50px"}
            textSize={"text-size-3"}
            isDisabled={textAreaValue === ""}
            clickHandler={async () => {
              await postUserMessageToSlack({
                teamName: user.teamName,
                email: user.email,
                message: textAreaValue,
                messageType: "feedback",
              });
              notificationDispatch({
                type: "ADD",
                payload: {
                  header: "Success",
                  message: "Feedback submitted",
                  type: "success",
                  autoDismiss: true,
                },
              });
              setModalState(!modalState);
              setTextAreaValue("");
            }}
          />
          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
        </div>
      </ComponentLibrary.PCDialogueBox>
    </div>
  );
}
